// extracted by mini-css-extract-plugin
module.exports = {"container":"oSc5Urn"};